import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Dialog from '@material-ui/core/Dialog';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import XLSX from 'xlsx'
import Button from '@material-ui/core/Button';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import AddIcon from '@material-ui/icons/Add';
import FullscreenLoader from './../../common/components/FullscreenLoader';
import moment from "moment-timezone";
import { raiseReturnRequest } from "../../store/actions/delivery.actions";
import NotificationIcon from '../../common/components/NotificationIcon';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { getNewBrand } from '../../common/components/util';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from '@material-ui/icons/Search';
import { getMaterialGroups } from '../../store/actions/materialGroups.actions';
import Tooltip from '@material-ui/core/Tooltip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WarningIcon from "@material-ui/icons/Warning";
import DialogContentText from '@material-ui/core/DialogContentText';
import { addNewStockRule, deleteStockRule, getManageStock } from '../../store/actions/dealer.action';
import { getTBLPartsAPI } from '../../store/actions/createUpdateEnquiry.actions';
import _, { get } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import GetAppIcon from '@material-ui/icons/GetApp';
import RefreshIcon from '@material-ui/icons/Refresh';
import ReplayIcon from '@material-ui/icons/Replay';
import ReturnRequestPopup from '../ReturnRequest/ReturnRequestPopup';
import ReturnAllRequestPopup from '../ReturnRequest/ReturnAllRequestPopup';
import { getBillingDetails, saveReturnRequestAPI, cancelReturnRequest } from "../../store/actions/delivery.actions";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import ReturnExcessPartPopup from '../ReturnRequest/ReturnExcessPart';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    actionButtons: {
        display: 'flex',
        gap: 16,
        marginTop: 24,
        marginBottom: 24,
    },
    actionButton: {
        color: '#1A9FE0',
        '&.Mui-disabled': {
            opacity: 0.5,
            color: '#1A9FE0',
        },
    },
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 24,
    },
    pageTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
        fontFamily: 'Nunito',
        color: '#1a1a1a',
        margin: 0,
    },
    iconGroup: {
        marginLeft: 'auto',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
    },
    invoiceHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 14,
    },
    invoiceInfo: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
    },
    invoiceId: {
        fontSize: '1.125rem',
        fontWeight: 700,
        fontFamily: 'Nunito',
        color: '#1a1a1a',
        margin: 0,
    },
    invoiceDate: {
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        color: '#140c0cff',
        margin: 0,
        fontWeight: 600,
        paddingTop: 6
    },
    headerActions: {
        display: 'flex',
        gap: 16,
        alignItems: 'center',
    },
    backButton: {
        color: '#1A9FE0',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    exportButton: {
        backgroundColor: 'transparent',
        color: '#1A9FE0',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 16px',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: '#f0f9ff',
        },
    },
    grossValue: {
        fontSize: '1rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1a1a1a',
        margin: 0,
    },
    tableContainer: {
        backgroundColor: '#ffffff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    tableHeader: {
        backgroundColor: '#ffffff',
    },
    headerCell: {
        color: '#133F8A',
        fontWeight: 900,
        fontSize: '0.75rem',
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '2px solid #e0e0e0',
        padding: '16px',
        whiteSpace: 'nowrap',
    },
    headerCell1: {
        color: '#133F8A',
        fontWeight: 900,
        textAlign: 'center',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        backgroundColor: '#f2f2f2',
        borderBottom: '2px solid #e0e0e0',
        padding: '16px',
        whiteSpace: 'nowrap',
    },
    subHeaderText: {
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        color: '#161212ff',
        marginTop: 4,
    },
    bodyCell: {
        color: '#666666',
        fontWeight: 600,
        fontSize: 12,
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
    },
    bodyCell1: {
        color: '#666666',
        fontWeight: 600,
        fontSize: 12,
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
        backgroundColor: '#f2f2f2',
        textAlign: 'center'
    },
    returnButton: {
        backgroundColor: '#FFF5E6',
        color: '#FF9800',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 16px',
        borderRadius: 16,
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        minWidth: '100px', // Add minimum width
        justifyContent: 'center', // Center content
        '&:hover': {
            backgroundColor: '#FFE5B4',
        },
        '&:disabled': {
            backgroundColor: '#f5f5f5',
            color: '#cccccc',
            cursor: 'not-allowed',
        },
    },
    updateButton: {
        backgroundColor: 'transparent',
        color: '#FF9800',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 8px',
        borderRadius: 16,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        cursor: 'pointer',
        minWidth: '85px', // Add minimum width
        justifyContent: 'center', // Center content
        whiteSpace: 'nowrap', // Prevent text wrapping
    },
    cancelButton: {
        backgroundColor: 'transparent',
        color: '#D32F2F',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 8px',
        borderRadius: 16,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        cursor: 'pointer',
        minWidth: '85px', // Add minimum width
        justifyContent: 'center', // Center content
        whiteSpace: 'nowrap', // Prevent text wrapping
    },
    fullyReturnedText: {
        color: '#D32F2F',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 8px',
        borderRadius: 16,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        minWidth: '85px',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
        cursor: 'default',
        backgroundColor: 'transparent',
    },
    fullyReturnedText1: {
        color: '#D32F2F',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 8px',
        borderRadius: 16,
        border: 'none',
        minWidth: '85px',
        justifyContent: 'left',
        whiteSpace: 'nowrap',
        cursor: 'default',
        backgroundColor: 'transparent',
    },

    actionButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 4,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '180px', // Match the combined width
    },
    actionButtonsContainer1: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '180px', // Match the combined width
    },
    buttonSection: {
        display: 'flex',
        alignItems: "center",
        justifyContent: 'space-between',
    },
    actionButtons1: {
        display: 'flex',
        gap: 16,
    },
    returnAllButton: {
        backgroundColor: '#FF9800',
        color: '#ffffff',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 32px',
        borderRadius: 24,
        '&.Mui-disabled': {
            backgroundColor: '#FFB74D',
            color: '#ffffff'
        },
        '&:hover': {
            backgroundColor: '#FF9800',
        },
    },
    paginationContainer: {
        borderTop: '1px solid #e0e0e0',
    },
    returnRequestedRow: {
        backgroundColor: '#FFF9E6 !important',
    },
    excessRow: {
        backgroundColor: '#bcdeef5c !important',
    },
    counterBadge: {
        position: "absolute",
        top: -15,
        right: 6,
        backgroundColor: '#D32F2F',
        color: '#ffffff',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        borderRadius: '50%',
        minWidth: 24,
        height: 24,
        padding: '0 6px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 8,
        pointerEvents: 'none',
        boxSizing: 'border-box',
    },
    returnRequestButton: {
        position: 'relative',
        backgroundColor: '#FF9800',
        color: '#ffffff',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 32px',
        borderRadius: 24,
        '&.Mui-disabled': {
            backgroundColor: '#FFB74D',
            color: '#ffffff'
        },
        '&:hover': {
            backgroundColor: '#FF9800',
        },
    },
}));

export default function ViewInvoice() {
    const classes = useStyles();
    const history = useHistory()
    const [page, setPage] = React.useState(0);
    const rowsPerPage = 10;
    const dispatch: Dispatch<any> = useDispatch();
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [searchText, setSearchText] = React.useState<any>('');
    const { getManageStockData }: any = useSelector((state: any) => state.dealer);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isEdit, setIsEdit] = React.useState(false);
    const [selectedPartNumber, setSelectedPartNumber] = React.useState<any>('');
    const [openDialog, setOpenDialog] = React.useState<any>(false);
    const [loading, setLoading] = React.useState<any>(false);
    const [selectedStockItem, setSelectedStockItem] = React.useState<{
        partNumber: string;
        brand: string;
        stockPercentage: number;
    } | null>(null);
    const [isUpdateMode, setIsUpdateMode] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");
    const [showReturnRequestPopup, setShowReturnRequestPopup] = React.useState<boolean>(false);
    const [showReturnExcessPartPopup, setShowReturnExcessPartPopup] = React.useState<boolean>(false);
    const [showAllReturnRequestPopup, setShowAllReturnRequestPopup] = React.useState<boolean>(false);
    const { viewDelivery, billingDetails, deleteReturnRequestDetails, getReturnOrderDetails }: any = useSelector((state: any) => state.delivery);
    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const InoviceDate = sessionStorage.getItem("InoviceDate")
    const InoviceDateTime = sessionStorage.getItem("selectedOrderCreatedOn")
    const isFSE = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre';
    const [returnRequests, setReturnRequests] = React.useState<any>({});
    const [showCancelDialog, setShowCancelDialog] = React.useState<boolean>(false);
    const [showReturnDialog, setReturnDialog] = React.useState<boolean>(false);
    const [itemToCancel, setItemToCancel] = React.useState<any>(null);
    const [selectedReturnItem, setSelectedReturnItem] = React.useState<any>(null);
    const b2bUserId = _.get(profileDetails, "data.data.basicInfo.b2bUserId", "");
    const location = useLocation();
    // Replace the existing etag state declaration (around line 60)
    const [etag, setEtag] = React.useState<any>("");
    const featureAccessibility: any = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.accessParameter && profileDetails.data.data.accessParameter.featureAccessibility);
    const isSalesReturnAccess = profileDetails?.data?.data?.customerInfo?.isSalesReturnAccess;

    const formatDate = (isoDate: string) => isoDate?.split('T')[0] || "";
    const orgIdBrandsMapping: any = {
        "Toyota": "2001",
        "Honda": "2002",
        "Famco": "2003",
        "TE": "2380",
        "OES": "2195",
        "BYD": "2092"
    }

    // Check if Sales Return feature is enabled (only for non-FSE users)
    const salesReturnAccess = isFSE ? true : (featureAccessibility?.find(
        (feature: any) => feature.featureCode === "SALES_RETURN"
    )?.value || false);

    // Add this useEffect right after your existing useEffects (around line 85)
    useEffect(() => {
        // Initialize etag from billingDetails when component mounts or billingDetails updates
        if (billingDetails?.data?.data?.data?._etag) {
            setEtag(billingDetails.data.data.data._etag);
        }
    }, [billingDetails]);

    // Get invoice data from billingDetails
    const invoiceData = billingDetails?.data?.data || null;
    const invoiceId = invoiceData?.data?.invoiceId;
    // Add effect to load auto-saved data
    // useEffect(() => {
    //     if (invoiceId) {
    //         const savedData = sessionStorage.getItem(`returnRequests_${invoiceId}`);
    //         if (savedData) {
    //             try {
    //                 const parsedData = JSON.parse(savedData);
    //                 setReturnRequests(parsedData);
    //             } catch (error) {
    //                 console.error('Error loading auto-saved data:', error);
    //             }
    //         }
    //     }
    // }, [invoiceId]);

    // // Add effect to auto-save data
    // useEffect(() => {
    //     if (invoiceId && Object.keys(returnRequests).length > 0) {
    //         sessionStorage.setItem(`returnRequests_${invoiceId}`, JSON.stringify(returnRequests));
    //     }
    // }, [returnRequests, invoiceId]);

    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };

    const getInvoiceDetails = async () => {
        setLoading(true);
        const sessionDetails = {
            webApplicationLoginId: webApplicationLoginId,
            clientIPAddress: sessionStorage.getItem("clientIp"),
        };

        const billingData = billingDetails?.data?.data?.data;
        const payload = {
            sapCustomerId: billingData?.sapCustomerId || "",
            customerName: isFSE
                ? billingData?.customerName
                : sessionStorage.getItem("customerName"),
            invoiceNumber: billingData?.invoiceNumber || "",
            orderNumber: billingData?.orderNumber || "",
            enquiryNumber: billingData?.enquiryNumber || "",
            sessionDetails,
            orgId: billingData?.orgId || viewDelivery?.data?.orgid || "",
            make: viewDelivery?.data?.make || "",
        };
        try {
            const responseData: any = await dispatch(getBillingDetails(payload));
            if (responseData?.status === 400 || responseData?.error) {
                handleopenCloseSnackbar(false);
                setSuccessMessage("");
                setShowErrorMessage(
                    responseData?.error ||
                    responseData?.statusText?.data?.error ||
                    responseData?.message
                );
                handleopenCloseErrorSnackbar(true);
            }
            else {
                handleopenCloseErrorSnackbar(false);
                setShowErrorMessage("");
                setSuccessMessage(responseData?.message?.message || responseData?.message);
                handleopenCloseSnackbar(true);
            }
        } catch (error) {
            handleopenCloseSnackbar(false);
            setSuccessMessage("");
            setShowErrorMessage("Unable to fetch invoice details.");
            handleopenCloseErrorSnackbar(true);
        } finally {
            setLoading(false);
        }
    };

    const exportInvoice = () => {
        if (invoiceData) {
            let filename = `Invoice - ${invoiceData?.data?.invoiceNumber}.xlsx`;
            let data: any = []
            invoiceData?.data?.itemDetails.map((item: any, index: number) => {
                const returnData = returnRequests[item.materialNumber] || {};
                // Use explicit checks instead of || to avoid falsy 0 issues
                const exportReturnQty = (item.returnQty !== undefined && item.returnQty !== null && item.returnQty !== '')
                    ? item.returnQty
                    : (returnData.returnQty !== undefined && returnData.returnQty !== null && returnData.returnQty !== '')
                        ? returnData.returnQty
                        : 0;

                const exportReturnNetValue = (item.returnNetValue !== undefined && item.returnNetValue !== null && item.returnNetValue > 0)
                    ? item.returnNetValue
                    : (returnData.returnNetValue !== undefined && returnData.returnNetValue !== null && returnData.returnNetValue > 0)
                        ? returnData.returnNetValue
                        : 0;

                data.push({
                    'Sr. No.': index + 1,
                    'Part No.': item.materialNumber || '-',
                    'Description': item.description || '-',
                    'Delivered Qty': item.deliveredQty || 0,
                    'Returned Qty': item.returnedQty || 0,
                    'Eligible for Return': item.eligibleReturnQty || 0,
                    'Unit Price (Excl. VAT)': item.netPrice ? Number(item.netPrice.toFixed(2)) : 0,
                    'Net Value (Excl. VAT)': item.netValue ? Number(item.netValue.toFixed(2)) : 0,
                    'Return Qty': exportReturnQty,
                    'Return Net Value (Excl. VAT)': exportReturnNetValue ? Number(exportReturnNetValue.toFixed(2)) : 0,
                })
                return undefined;
            })

            var ws = XLSX.utils.json_to_sheet(data);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "sheet1");
            XLSX.writeFile(wb, filename);
        }
    }

    const handleopenCloseSnackbar = (open?: boolean) => {
        setOpenSnackbar(!!open);
    };

    const handleopenCloseErrorSnackbar = (open?: boolean) => {
        setOpenErrorSnackbar(!!open);
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    // Replace the existing handleReturnSuccess function (around line 138)
    const handleReturnSuccess = (materialNumber: string, returnData: any, responseEtag?: string) => {
        if (responseEtag) {
            setEtag(responseEtag);
        }
        setShowReturnRequestPopup(false);
        setSelectedRow(null);
        setSelectedReturnItem(null);
    };

    const hasAnyEligibleReturnQty = () => {
        const items = billingDetails?.data?.data?.data?.itemDetails || [];
        return items.some((item: any) =>
            item.eligibleReturnQty > 0 &&
            !(item.status === 'Submitted' && item.returnNetValue && item.returnNetValue > 0)
        );
    };

    const handleUpdateReturn = (item: any, isAccess?: any) => {
        const returnHistory = getReturnHistoryForItem(item.materialNumber, item.returnRequestId);

        const existingData = (item.returnNetValue && item.returnNetValue > 0) || isAccess
            ? {
                returnQty: item.returnQty,
                returnReason: returnHistory?.reason || '',
                returnImages: returnHistory?.returnImages || {},
                comment: returnHistory?.comment || returnHistory?.message || '',
                returnNetValue: item.returnNetValue,
                returnRequestId: item.returnRequestId,
                status: returnHistory?.status || item.status,
                materialNumber: item.materialNumber,
                description: item.description,
                isExcessPart: item.isExcessPart
            }
            : null;

        setSelectedReturnItem({
            ...item,
            existingReturnData: existingData,
            reason: returnHistory?.reason
        });
        setSelectedRow(item);
        if (isAccess) {
            setShowReturnExcessPartPopup(true)
        } else {
            setShowReturnRequestPopup(true);
        }
        setIsUpdateMode(true);
    };

    const handleCancelReturn = (item: any) => {
        setItemToCancel(item);
        setSelectedReturnItem(item);
        setShowCancelDialog(true);
    };

    const cancelReturnRequestAPI = async () => {
        setLoading(true);
        const payload = {
            "id": billingDetails?.data?.data?.data?.id,
            "materialNumber": itemToCancel?.materialNumber,
            "itemId": itemToCancel?.itemId
        };

        let responseData: any = await dispatch(cancelReturnRequest(payload));

        if (responseData && responseData.status === 400) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage(responseData?.error);
            setLoading(false);
        } else {
            if (responseData?.data?.data?._etag) {
                setEtag(responseData.data.data._etag);
            }

            setOpenErrorSnackbar(false);
            handleopenCloseSnackbar(true);
            setSuccessMessage(responseData && responseData.message && responseData.message.message);
            setLoading(false);

            setShowCancelDialog(false);
            setItemToCancel(null);
        }
    };

    const handleConfirmCancel = () => {
        cancelReturnRequestAPI();
    };
    const isInvoiceOlderThan7Days = (): boolean => {
        const invoiceDateStr = InoviceDate;

        if (!invoiceDateStr) return false;

        const [day, monthStr, year] = invoiceDateStr.split(" ");
        if (!day || !monthStr || !year) return false;

        const monthNames: Record<string, number> = {
            Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
            Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
        };
        const month = monthNames[monthStr];
        if (month === undefined) return false;

        const invoiceDate = new Date(Number(year), month, Number(day));
        invoiceDate.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const diffTime = today.getTime() - invoiceDate.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);


        // return diffDays > 7;
        // commented for testing purpose to enable return request for invoices older than 7 days
        return false;
    };



    const getTotalReturnValue = () => {
        // If API has totalReturnValue, use it directly
        if (invoiceData?.data?.totalReturnValue && invoiceData.data.totalReturnValue > 0) {
            return invoiceData.data.totalReturnValue;
        }

        // Otherwise calculate from local state
        return Object.values(returnRequests).reduce((sum: number, request: any) => {
            return sum + (request.returnNetValue || 0);
        }, 0);
    };

    const getReturnHistoryForItem = (materialNumber: string, returnRequestId: string) => {
        return invoiceData?.data?.returnHistoryList?.find(
            (history: any) => history.materialNumber === materialNumber && history.returnRequestId === returnRequestId
        );
    };

    const getReturnRequestCount = (): number => {
        return invoiceData?.returnRequestCount ?? 0;
    };

    const handleReturnRequest = async () => {
        setLoading(true);
        try {
            const sessionDetails = {
                webApplicationLoginId: webApplicationLoginId,
                clientIPAddress: sessionStorage.getItem("clientIp"),
            };
            let userRole: any = sessionStorage.getItem('userType-Profile-API')
            const billingData = billingDetails?.data?.data?.data;
            // Filter itemDetails for submitted status items, then match with returnHistoryList
            const returnData = billingData?.itemDetails
                ?.filter((item: any) => item.status === 'Submitted')
                ?.map((item: any) => {
                    return {
                        materialNumber: item.materialNumber,
                        itemId: item.itemId,
                        description: item.description ?? "",
                        deliveredQty: item.deliveredQty ?? 0,
                        netValue: item.netValue ?? 0,
                        netPrice: item.netPrice ?? 0,
                        itemNumber: item.billingItem,
                        eligibleReturnQty: item.eligibleReturnQty ?? 0,
                        returnQty: item?.returnQty ?? 0,
                        returnNetValue: item.netPrice ? item.netPrice * (item?.returnQty ?? 0) : 0,
                        returnedQty: item?.returnedQty ?? 0,
                    };
                }) ?? [];
            const payload = {
                invoiceNumber: billingData?.invoiceNumber,
                userId: userRole === 'FSE' || userRole.toLowerCase() === 'sre' ? webApplicationLoginId : b2bUserId,
                invoiceDate: InoviceDate || "",
                returnData,
                createdBy: billingData?.customerName,
                sapCustomerId: billingData?.sapCustomerId,
                sessionDetails,
                role: userRole,
                orgId: billingData?.orgId || "",
                make: billingData?.brand || "",
            };
            const responseData: any = await dispatch(raiseReturnRequest(payload));

            const isFailure =
                !responseData ||
                responseData.status === 400 ||
                (responseData.status && responseData.status >= 400) ||
                responseData.error ||
                responseData.success === false;

            if (isFailure) {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    responseData?.error ||
                    responseData?.message?.message ||
                    responseData?.message ||
                    "Failed to process return request. Please try again."
                );
            } else {
                setOpenErrorSnackbar(false);
                handleopenCloseErrorSnackbar(false);
                history.push("/returnorder");
            }
        } catch (error) {
            console.error("Return request error:", error);
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage("Failed to process return request");
        } finally {
            setLoading(false);
            setReturnDialog(false);
        }
    };
    const isReturnDisabled = isInvoiceOlderThan7Days();



    return (
        <div className={classes.root}>
            {loading && <FullscreenLoader />}
            {billingDetails && billingDetails.loading && <FullscreenLoader />}

            <Snackbar
                open={openSnackbar}
                message={successMessage}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false)
                }} />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                message={showErrorMessage}
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false)
                }} />
            <div className="d-flex align-items-center mt-2 mb-4">
                <h2 className="page-title">
                    View Invoice</h2>
                <div className="ml-auto">
                    <AnnouncementIcon />
                    <NotificationIcon />
                </div>
            </div>

            {/* Invoice Header */}
            <div className={`${classes.invoiceHeader} view-invoice`}>
                <div className={classes.invoiceInfo}>
                    <p className={classes.invoiceId}>Invoice No: {invoiceData?.data?.invoiceNumber || '-'}</p>
                    <p className={classes.invoiceDate}>Date: {InoviceDate ? InoviceDate : '-'}</p>
                </div>

                <div className={classes.headerActions}>
                    {(isFSE || isSalesReturnAccess) && (
                        <Tooltip
                            title={
                                isReturnDisabled
                                    ? "Return allowed only within 6 days from invoice"
                                    : ""
                            }
                            disableHoverListener={!isReturnDisabled}
                        >
                            <span>
                                <IconButton
                                    onClick={() => setShowReturnExcessPartPopup(true)}
                                    className={`ml-auto ${classes.actionButton}`}
                                    // disabled={isReturnDisabled}
                                    disabled
                                >
                                    <ReplayIcon fontSize="small" />
                                    <span className="backLinkLabel">
                                        Return Excess Part/Quantity
                                    </span>
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                    {sessionStorage.getItem("searchByInvoice") === "true" ? (
                        <IconButton
                            onClick={() => { history.push(`/searchinvoice`); }}
                            className={`ml-auto ${classes.actionButton}`}
                        >
                            <ChevronLeftIcon fontSize="small" />
                            <span className="backLinkLabel">Back to List</span>
                        </IconButton>
                    ) : (
                        <IconButton
                            onClick={() => { history.push(`/deliverylist`); }}
                            className={`ml-auto ${classes.actionButton}`}
                        >
                            <ChevronLeftIcon fontSize="small" />
                            <span className="backLinkLabel">Back to List</span>
                        </IconButton>
                    )}
                    <Button
                        className={classes.exportButton}
                        startIcon={<GetAppIcon />}
                        onClick={() => exportInvoice()}
                        disabled={!invoiceData || !invoiceData.data.itemDetails || invoiceData.data.itemDetails.length === 0}
                    >
                        Export to Excel
                    </Button>
                    <p className={classes.grossValue}>
                        Gross value (Incl. of VAT) : {invoiceData?.data?.grossValue ?
                            `AED ${invoiceData?.data?.grossValue}`
                            : 'AED 0.00'}
                    </p>
                </div>
            </div>

            {/* Table */}
            <div className={classes.tableContainer}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead className={classes.tableHeader}>
                            <TableRow>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    SN.
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    Part No.
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 180 }}>
                                    Description
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    Delivered Qty
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    Returned Qty
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    Eligible for Return
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    <div className='mt-3 pt-0 pb-0'>Unit Price</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    <div className='mt-3 pt-0 pb-0'>Net Value</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell1} style={{ width: 100 }}>
                                    Return Qty
                                </TableCell>
                                <TableCell className={classes.headerCell1} style={{ width: 120 }}>
                                    <div className='mt-4 pt-0 pb-0'>Return Net Value</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                {salesReturnAccess && (
                                    <TableCell className={classes.headerCell} style={{ width: 180, minWidth: 180 }}>
                                        Action
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoiceData && invoiceData.data && invoiceData.data.itemDetails && invoiceData.data.itemDetails.length > 0 ? (
                                invoiceData.data.itemDetails
                                    .map((item: any, index: number) => {
                                        // Check if return request exists for THIS specific itemId
                                        const hasReturnFromAPI = item.status === 'Submitted' && item.returnNetValue && item.returnNetValue > 0;
                                        const isReturnRequested = hasReturnFromAPI;
                                        // Get the display values from API only
                                        const displayReturnQty = item.returnQty || '-';
                                        const displayReturnNetValue = item.returnNetValue || null;
                                        const isAccess = item.isExcessPart === true;
                                        const isAccessApproved = item.isExcessPart === true && item.returnQty === '' && item.returnedQty !== '' ? true : false
                                        return (
                                            <TableRow
                                                key={`${item.itemId}-${index}`}
                                                className={isReturnRequested ? classes.returnRequestedRow : isAccess ? classes.excessRow : ''}
                                            >
                                                <TableCell className={classes.bodyCell}>{index + 1}</TableCell>
                                                <TableCell className={classes.bodyCell}>{item.materialNumber || '-'}</TableCell>
                                                <TableCell className={classes.bodyCell}>{item.description || '-'}</TableCell>
                                                <TableCell className={classes.bodyCell} align="center">
                                                    {isAccess ? '-' : item.deliveredQty || 0}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell} align="center">
                                                    {item.returnedQty || '-'}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell} align="center">
                                                    {isAccess ? '-' : item.eligibleReturnQty || 0}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell} align="right">
                                                    {(item.netPrice && !isAccess) ? item.netPrice.toFixed(2) : '-'}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell} align="right">
                                                    {item.netValue && !isAccess ? item.netValue.toFixed(2) : '-'}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell1} align="center">
                                                    {displayReturnQty}
                                                </TableCell>
                                                <TableCell className={classes.bodyCell1} align="center">
                                                    {displayReturnNetValue && !isAccess ? displayReturnNetValue.toFixed(2) : '-'}
                                                </TableCell>
                                                {(salesReturnAccess || isAccess) && (
                                                    <TableCell className={classes.bodyCell} align="center" style={{ minWidth: '180px' }}>
                                                        {isAccessApproved ? (<div className={`${classes.fullyReturnedText} mt-1 pb-0`}>
                                                            Fully returned
                                                        </div>) :
                                                            (isReturnRequested || isAccess) ? (
                                                                <div className={classes.actionButtonsContainer}>
                                                                    <button
                                                                        className={classes.updateButton}
                                                                        onClick={() => handleUpdateReturn(item, isAccess ? true : false)}
                                                                    >
                                                                        <RefreshIcon style={{ fontSize: 16 }} />
                                                                        Update
                                                                    </button>
                                                                    <button
                                                                        className={classes.cancelButton}
                                                                        onClick={() => handleCancelReturn(item)}
                                                                    >
                                                                        <CloseIcon style={{ fontSize: 16 }} />
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className={classes.actionButtonsContainer1}>
                                                                    <button
                                                                        className={classes.returnButton}
                                                                        onClick={() => {
                                                                            setSelectedReturnItem(item);
                                                                            setSelectedRow(item);
                                                                            setIsUpdateMode(false);
                                                                            setShowReturnRequestPopup(true);
                                                                        }}
                                                                        disabled={!item.eligibleReturnQty || item.eligibleReturnQty === 0 || isInvoiceOlderThan7Days()}
                                                                    >
                                                                        <RefreshIcon style={{ fontSize: 16 }} />
                                                                        Return
                                                                    </button>
                                                                    {(!item.eligibleReturnQty || item.eligibleReturnQty === 0) && (
                                                                        <div className={`${classes.fullyReturnedText} mt-1 pb-0`}>
                                                                            Fully returned
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        );
                                    })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={10} align="center" className={classes.bodyCell}>
                                        Invoice details are unavailable.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <div className={`${classes.buttonSection} pl-2 py-3`}>
                    <div className={classes.actionButtons1} >
                        {salesReturnAccess && (
                            <>
                                <Button
                                    className={classes.returnRequestButton}
                                    onClick={() => {
                                        if (getReturnRequestCount() > 99) {
                                            setOpenErrorSnackbar(true);
                                            handleopenCloseErrorSnackbar(true);
                                            setShowErrorMessage(
                                                "This return request exceeds the 99 item limit. Kindly contact Al‑Futtaim Sales Team for further assistance."
                                            );
                                            return;
                                        }
                                        setReturnDialog(true);
                                    }}
                                    disabled={getReturnRequestCount() === 0 || getTotalReturnValue() >= 50000}
                                >
                                    Return Request
                                    {getReturnRequestCount() > 0 && (
                                        <span className={classes.counterBadge}>
                                            {getReturnRequestCount()}
                                        </span>
                                    )}
                                </Button>
                                {isFSE && (
                                    <Button
                                        disabled={getReturnRequestCount() === billingDetails?.data?.data?.data?.itemDetails?.length || isInvoiceOlderThan7Days() || !isFSE || !hasAnyEligibleReturnQty()}
                                        onClick={() => {
                                            const allEligibleItems = billingDetails?.data?.data?.data?.itemDetails?.filter(
                                                (item: any) => item.eligibleReturnQty > 0
                                            ) || [];

                                            if (allEligibleItems.length > 99) {
                                                setOpenErrorSnackbar(true);
                                                handleopenCloseErrorSnackbar(true);
                                                setShowErrorMessage(
                                                    "This return request exceeds the 99 item limit. Kindly contact Al‑Futtaim Sales Team for further assistance."
                                                );
                                                return;
                                            }

                                            setSelectedReturnItem({
                                                returnItem: allEligibleItems.map((item: any) => ({
                                                    materialNumber: item.materialNumber,
                                                    returnQty: item.eligibleReturnQty,
                                                    itemId: item.itemId,
                                                    reason: "",
                                                }))
                                            });
                                            setShowAllReturnRequestPopup(true);
                                        }}
                                        className={classes.returnAllButton}
                                        startIcon={<RefreshIcon />}
                                    >
                                        Return All
                                    </Button>
                                )}
                            </>
                        )}
                        <p className={`${classes.grossValue} pt-2 pr-4`} >
                            Estimated Total Return Value (Excl. of VAT) : AED {getTotalReturnValue().toFixed(2)}
                        </p>
                    </div>
                </div>
                <div className="px-3 mt-2">
                    {getTotalReturnValue() >= 50000 && (
                        <p
                            className={`${classes.fullyReturnedText1} bg-red-100  text-red-700 rounded px-0.5 pb-3 pt-0`}
                        >
                            Return value should not be more than or equal to AED 50,000. Kindly contact Al-Futtaim Sales Team for assistance.
                        </p>
                    )}
                </div>


                {showReturnRequestPopup && (
                    <ReturnRequestPopup
                        open={showReturnRequestPopup}
                        handleopenClose={() => {
                            setShowReturnRequestPopup(false);
                            setSelectedRow(null);
                            setSelectedReturnItem(null);
                            setIsUpdateMode(false);
                        }}
                        selectedItem={selectedReturnItem}
                        invoiceData={invoiceData}
                        existingReturnData={(() => {
                            if (selectedReturnItem?.existingReturnData) {
                                return selectedReturnItem.existingReturnData;
                            }
                            if (selectedReturnItem && selectedReturnItem.returnNetValue && selectedReturnItem.returnNetValue > 0) {
                                const returnHistory = getReturnHistoryForItem(selectedReturnItem.materialNumber, selectedReturnItem.returnRequestId);
                                return {
                                    returnQty: selectedReturnItem.returnQty,
                                    returnReason: returnHistory?.reason || '',
                                    returnImages: returnHistory?.returnImages || {},
                                    comment: returnHistory?.comment || returnHistory?.message || '',
                                    returnNetValue: selectedReturnItem.returnNetValue
                                };
                            }

                            return null;
                        })()}
                        isUpdateMode={isUpdateMode}
                        onReturnSuccess={handleReturnSuccess}
                        currentEtag={etag}
                    />
                )}
                {showReturnExcessPartPopup && (
                    <ReturnExcessPartPopup
                        open={showReturnExcessPartPopup}
                        handleopenClose={() => {
                            setShowReturnExcessPartPopup(false);
                            setSelectedRow(null);
                            setSelectedReturnItem(null);
                            setIsUpdateMode(false);
                        }}
                        selectedItem={selectedReturnItem}
                        invoiceData={invoiceData}
                        onReturnSuccess={handleReturnSuccess}
                        existingReturnData={(() => {
                            if (selectedReturnItem?.existingReturnData) {
                                return selectedReturnItem.existingReturnData;
                            }

                            if (selectedReturnItem && selectedReturnItem.returnNetValue && selectedReturnItem.returnNetValue > 0) {
                                const returnHistory = getReturnHistoryForItem(selectedReturnItem.materialNumber, selectedReturnItem.returnRequestId);
                                return {
                                    returnQty: selectedReturnItem.returnQty,
                                    returnReason: returnHistory?.reason || '',
                                    returnImages: returnHistory?.returnImages || {},
                                    comment: returnHistory?.comment || returnHistory?.message || '',
                                    returnNetValue: selectedReturnItem.returnNetValue
                                };
                            }

                            return null;
                        })()}
                        isUpdateMode={isUpdateMode}
                        getInvoiceDetails={getInvoiceDetails}
                        currentEtag={etag}
                    />
                )}

                {showAllReturnRequestPopup && (
                    <ReturnAllRequestPopup
                        open={showAllReturnRequestPopup}
                        handleopenClose={() => {
                            setShowAllReturnRequestPopup(false);
                            setSelectedRow(null);
                            setSelectedReturnItem(null);
                        }}
                        existingReturnData={(() => {
                            if (selectedReturnItem?.existingReturnData) {
                                return selectedReturnItem.existingReturnData;
                            }

                            if (selectedReturnItem && selectedReturnItem.returnNetValue && selectedReturnItem.returnNetValue > 0) {
                                const returnHistory = getReturnHistoryForItem(selectedReturnItem.materialNumber, selectedReturnItem.returnRequestId);
                                return {
                                    returnQty: selectedReturnItem.returnQty,
                                    returnReason: returnHistory?.reason || '',
                                    returnImages: returnHistory?.returnImages || {},
                                    comment: returnHistory?.comment || returnHistory?.message || '',
                                    returnNetValue: selectedReturnItem.returnNetValue
                                };
                            }

                            return null;
                        })()}

                        isUpdateMode={
                            (selectedReturnItem?.returnNetValue && selectedReturnItem.returnNetValue > 0)
                        }
                        onReturnSuccess={handleReturnSuccess}

                        selectedItem={selectedReturnItem}
                        invoiceData={invoiceData}
                        currentEtag={etag}
                    />
                )}
            </div>

            {/* Cancel Confirmation Dialog */}
            <Dialog
                open={showCancelDialog}
                onClose={() => setShowCancelDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogContent>
                    <div style={{ float: "left", margin: "0 20px 35px 0", height: "100%", fill: "white" }}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                    </div>
                    <DialogContentText id="alert-dialog-description" component="div">
                        <div style={{ marginTop: 12, color: '#616161', fontSize: '0.875rem', fontFamily: 'Nunito', fontWeight: 700 }}>
                            Are you sure you want to cancel this return request ?
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#1A9FE0', textTransform: 'capitalize' }}
                        onClick={handleConfirmCancel}
                        autoFocus
                    >
                        Yes
                    </Button>
                    <Button
                        style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#919191', textTransform: 'capitalize' }}
                        onClick={() => setShowCancelDialog(false)}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showReturnDialog}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    setReturnDialog(false);
                }}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogContent>
                    <div style={{ float: "left", margin: "0 20px 35px 0", height: "100%", fill: "white" }}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                    </div>
                    <DialogContentText id="alert-dialog-description" component="div">
                        <div style={{ marginTop: 12, color: '#616161', fontSize: '0.875rem', fontFamily: 'Nunito', fontWeight: 700 }}>
                            Are you sure you want to proceed with the return request ?
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#1A9FE0', textTransform: 'capitalize' }}
                        onClick={handleReturnRequest}
                        autoFocus
                    >
                        Proceed
                    </Button>
                    <Button
                        style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#919191', textTransform: 'capitalize' }}
                        onClick={() => setReturnDialog(false)}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}